import React, { useEffect, useRef, useState } from "react";
import LogoutButton from "../LogoutComponent";
import { ImUser } from "react-icons/im";
import { useNavigate } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import useUserLogin from "../../hooks/UserLoginhook";

const ProfileDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const { customColor } = useUserLogin();
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleProfileClick = () => {
    setIsOpen(false);
    setIsHovered(false);
    navigate("/paymentsolution/profile");
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
        setIsHovered(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <div>
        <button
          onClick={toggleDropdown}
          className="flex items-center justify-center w-8 h-8 bg-gray-300 rounded-full hover:bg-gray-400 focus:outline-none"
          aria-haspopup="true"
          aria-expanded={isOpen}
        >
          <ImUser className="text-xl text-slate-500" />
        </button>
      </div>

      {isOpen && (
        <div className="absolute right-0 z-10 mt-2 rounded-md shadow-lg w-52 bg-slate-100">
          <div className="relative">
            <div className="absolute -top-2 right-2.5 w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-8 border-b-white"></div>

            <button
              onClick={handleProfileClick}
              style={{ backgroundColor: isHovered ? customColor : "" }}
              className="flex items-center w-full gap-2 px-3 py-2 text-left text-gray-700 text-md hover:rounded-t-md hover:text-white"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <CgProfile />
              Profile
            </button>

            <LogoutButton />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;
